
export default {
    en: "English",
    nl:"Nederlands",
    de:"Deutsch",
    fr:"Francais",
    es:"Espanol"
  }